import React from 'react';

import { WorkInProgressView } from '../WorkInProgressView';

export const Month = () => <WorkInProgressView />;
